import React from 'react';
import { Modal } from '@buyhatke/react-ui';

import SliderItem from './item';

const IntentItemsList = ({ intentItems, closerFn }) => (
	<ul className="flex scroll-snap-type-x overflow-auto px-4">
		{intentItems.map(item => (
			<SliderItem {...item} key={item.heading} closer={closerFn} />
		))}
	</ul>
);

const IntentModal = ({
	openState,
	closer,
	upperContent,
	bottomHeading,
	modalHeading,
	intentItems,
	noBottom,
}) => (
	<Modal
		openMoi={openState}
		modalClose={closer}
		header={modalHeading}
		bodyClassName="pt-8"
		small={noBottom}
		footer={
			noBottom
				? [
						{
							type: 'close',
							text: 'close',
						},
				  ]
				: []
		}
	>
		{upperContent}
		{!noBottom && (
			<div className="py-8 bg-snowWhite">
				<h3 className="font-bold text-lg text-center text-lightGray mt-4 mx-8 mb-8">
					{bottomHeading}
				</h3>

				<IntentItemsList closerFn={closer} intentItems={intentItems} />
			</div>
		)}
	</Modal>
);

export default IntentModal;
